import React from "react";
import { Card, Container } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Trust.css";

const items = [
  {
    title: "Simple et efficace",
    text: "Nous simplifions chaque étape pour vous, rendant la gestion de votre entreprise facile.",
    img: "./images/trust/roquette.png",
    alt: "Simple et efficace",
  },
  {
    title: "Confiance",
    text: "Des centaines d'entrepreneurs nous ont choisis grâce à notre fiabilité et transparence.",
    img: "./images/trust/trust.png",
    alt: "Confiance",
  },
  {
    title: "Sécurité",
    text: "Nous garantissons la sécurité de vos données et un service conforme aux normes.",
    img: "./images/trust/verrouiller.png",
    alt: "Sécurité",
  },
  {
    title: "Économique",
    text: "Nos solutions sont abordables, sans compromis sur la qualité du service.",
    img: "./images/trust/tirelire.png",
    alt: "Économique",
  },
  {
    title: "100% web",
    text: "Gérez tout en ligne, où que vous soyez, avec une plateforme accessible et intuitive.",
    img: "./images/trust/web.png",
    alt: "100% web",
  },
];

const fade = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

const TrustSection = () => {
  return (
    <section className="trust-section" aria-labelledby="trust-title">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-5"
        >
          <p className="eyebrow">Pourquoi nous choisir</p>
          <h2 id="trust-title" className="hero-like-title">
            Pourquoi nous faire <span className="accent">confiance&nbsp;?</span>
          </h2>
          <p className="hero-subtitle text-muted mx-auto">
            Découvrez pourquoi des centaines d’entrepreneurs nous font confiance.
          </p>
        </motion.div>

        <div className="trust-grid">
          {items.map((box, idx) => (
            <motion.div
              key={box.title}
              variants={fade}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={idx}
            >
              <Card className="trust-card" tabIndex={0}>
                <div className="trust-icon">
                  <img src={box.img} alt={box.alt} />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="trust-title">{box.title}</Card.Title>
                  <Card.Text className="trust-text">{box.text}</Card.Text>
                </Card.Body>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TrustSection;
